import { Armenian, English, Russian } from "../Translations";
import i18next from "i18next";
import {initReactI18next} from "react-i18next";

const resources ={
  en:{
   translation : English
  },
  ru:{
   translation:Russian
  },
  hy:{
   translation :Armenian
  }
}

i18next
 .use(initReactI18next)
 .init({
    resources,
    lng:localStorage.getItem('p_m_language') ?? "hy"
 });

 export default i18next